import { Injectable } from '@angular/core';
import { SoundService } from '../parameter/sound/sound.service';

@Injectable({
  providedIn: 'root'
})
export class SoundManagerService {

  public sounds: any;

  constructor(
    private soundService: SoundService
  ) { }

  /**
   * Function to enable or disable the sound
   */
  public toggleSound(): void {
    this.soundService.set(!this.soundService.get());
  }

  /**
   * Function to play sound
   */
  public playSound(): void {
    const audio = new Audio();
    if (this.soundService.get()) {
      this.sounds.push(audio);
    }
  }
}
